import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBpPKA_ikIbLeVqCxwjKnpSXqSRUR1lJfY",
  authDomain: "my-test-bed-d0d2c.firebaseapp.com",
  projectId: "my-test-bed-d0d2c",
  storageBucket: "my-test-bed-d0d2c.appspot.com",
  messagingSenderId: "989537199470",
  appId: "1:989537199470:web:f318770bda890502b1cd7f",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();
const storage = getStorage();

export { auth, db, storage };
